// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import styled from 'styled-components';
import CheckBox from '../_common/form/CheckBox';
import Select from '../_common/form/Select';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import ThemeSelector from '../_common/ThemeSelector';
import Card from './Card';

const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0.5em;
`
const LocSelect = styled(Select)`
    width: 100%;
`
const Options = ({ ...props }) => {
    const {
        state: {
            site_config,
            active_user
        },
        setBubbles,
        setFontSize,
        setForcedLocation
    } = useGlobalState();

    return (
        <Card title='Options' icon='cog' collapsible>
            {/* <Row>
                <span>Color Theme</span>
                <ThemeSelector />
            </Row> */}

            <Row>
                <span>Bubbles</span>
                <CheckBox
                    standalone
                    onChange={() => setBubbles(!site_config.bubbles.enabled)}
                    checked={site_config.bubbles.enabled}
                />
            </Row>

            <Row>
                <LocSelect
                    standalone
                    nullable
                    label='Default Location'
                    value={active_user.forcedLocation || ''}
                    onChange={(e) => setForcedLocation(e.target.value)}
                    options={
                        [
                            ...site_config.locations
                                .map(e => {
                                    return {
                                        value: e.id,
                                        label: e.city
                                    }
                                })
                        ]
                    }
                />
            </Row>

            <Row>
                <span>Font Size ({(site_config.fontSize || 10) / 10})</span>
                <input
                    type='range'
                    min={5}
                    max={15}
                    step={1}
                    value={site_config.fontSize || 10}
                    onChange={e => setFontSize(e.target.value)}
                />
            </Row>
        </Card>
    );
}

export default Options;